
import { DEFAULT_CATEGORY_ICONS, getIconByName } from '@/data/categoryIcons';
import { Settings } from 'lucide-react';
import { useCategories } from '@/contexts/categories';

interface CategoryIconProps {
  iconName?: string;
  categoryName?: string;
  categoryId?: string;
  color: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8', 
  lg: 'w-10 h-10'
};

const iconSizeClasses = {
  sm: 'h-3 w-3',
  md: 'h-4 w-4',
  lg: 'h-5 w-5'
};

export const CategoryIcon = ({ 
  iconName, 
  categoryName, 
  categoryId,
  color, 
  size = 'md',
  className = '' 
}: CategoryIconProps) => {
  const { getCategoryById } = useCategories();
  
  // Tentar obter ícone por diferentes métodos
  let IconComponent = Settings; // Fallback padrão
  
  // 1. Primeiro, tentar usar iconName se fornecido
  if (iconName) {
    IconComponent = getIconByName(iconName);
  } 
  // 2. Se temos categoryId, buscar no contexto
  else if (categoryId) {
    const category = getCategoryById(categoryId);
    if (category?.icon) {
      IconComponent = getIconByName(category.icon);
    } else if (category?.name && DEFAULT_CATEGORY_ICONS[category.name]) {
      IconComponent = DEFAULT_CATEGORY_ICONS[category.name];
    }
  }
  // 3. Fallback para categoryName nos ícones padrão
  else if (categoryName && DEFAULT_CATEGORY_ICONS[categoryName]) {
    IconComponent = DEFAULT_CATEGORY_ICONS[categoryName];
  }

  return (
    <div 
      className={`${sizeClasses[size]} rounded-full flex items-center justify-center ${className}`}
      style={{ backgroundColor: color }}
    >
      <IconComponent className={`${iconSizeClasses[size]} text-white`} />
    </div>
  );
};
